// Lib
import { createAction } from 'redux-actions';

// Constants
import { ACTIVE } from 'constants/index';

export const getJobBoardStages = createAction('GET_JOB_BOARD_STAGES');
export const setJobBoardStages = createAction('SET_JOB_BOARD_STAGES');
export const removeRecruiterCandidate = createAction('REMOVE_RECRUITER_CANDIDATE');
export const moveCandidateToStage = createAction('MOVE_CANDIDATE_TO_STAGE');
export const rejectUserCandidate = createAction('REJECT_USER_CANDIDATE');
export const restoreRejectedCandidate = createAction(
  'RESTORE_REJECTED_CANDIDATE',
  (candidate: any) => ({
    ...candidate,
    status: ACTIVE,
  })
);

export const clearJobBoard = createAction('CLEAR_JOB_BOARD');
